export default __webpack_public_path__ + "static/media/video_bb_before.53af54c4.mp4";